import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    DeletionBanner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '2.125rem',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        width: '100%',
    },
    DeletionBannerLabel: {
        fontSize: '1.125rem',
        fontWeight: 600,
        lineHeight: '26px',
    },
    DeletionBannerSubLabel: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: '20px',
        color: theme.palette.typography.light,
    },
    DeletionBannerButton: {
        background: theme.palette.red.main,
        gap: '.5rem',
        [theme.breakpoints.up('md')]: {
            padding: '1rem 2rem',
        },
        '&:hover': {
            background: theme.palette.red.hover,
        },
        '& .MuiButton-startIcon': {
            marginRight: 0,
            '& svg': {
                width: '1.5rem',
                height: '1.5rem',
            },
        },
    },
    DeletionBannerButtonIcon: {},
    DeletionBannerDefaultContent: {
        backgroundColor: '#FAF1F3',
        width: '84px',
        height: '84px',
        borderRadius: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    DeletionBannerDefaultContentIcon: {
        color: `${theme.palette.red.main}`,
        fontSize: '58px',
    },
}))
